import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_DIRECTORY_CLIENT_LIST,
    CLEAR_DIRECTORY_CLIENT_LIST_ERROR,
    LOAD_DIRECTORY_CLIENT_LIST_REQUEST,
    LOAD_DIRECTORY_CLIENT_LIST_SUCCESS,
    LOAD_DIRECTORY_CLIENT_LIST_FAILURE
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_DIRECTORY_CLIENT_LIST,
    CLEAR_ERROR: CLEAR_DIRECTORY_CLIENT_LIST_ERROR,
    LOAD_REQUEST: LOAD_DIRECTORY_CLIENT_LIST_REQUEST,
    LOAD_SUCCESS: LOAD_DIRECTORY_CLIENT_LIST_SUCCESS,
    LOAD_FAILURE: LOAD_DIRECTORY_CLIENT_LIST_FAILURE
}